import { createAsyncAction } from "typesafe-actions";
import { ApexApiError } from "types";
import {
  FETCH_MENU_ITEMS_REQUEST,
  FETCH_MENU_ITEMS_SUCCESS,
  FETCH_MENU_ITEMS_FAILURE,
} from "./constants";

export const fetchMenuItems = createAsyncAction(
  FETCH_MENU_ITEMS_REQUEST,
  FETCH_MENU_ITEMS_SUCCESS,
  FETCH_MENU_ITEMS_FAILURE
)<undefined, string, ApexApiError>();
